import React from 'react'
import MiniProjectNoDataScreen from './MiniProjectNoDataScreen'
import MiniProjectList from './MiniProjectList'
import './miniProject.min.css'
import AddMiniProjectModal from './AddMiniProjectModal';
import EditMiniProjectModal from './EditMiniProjectModal';
import DeleteProjectModal from './DeleteProjectModal';
import AddTaskModal from './ProjectDetails/AddTaskModal';
import { UserAuth } from '../auth/Auth';

function ProjectIndex() {
    const { MatchPermission } = UserAuth();
    
    // ================== ALL HOOKS MUST BE AT THE TOP ==================
    // Add Project Modal start
    const [showAddProjectModal, setShowAddProjectModal] = React.useState(false);
    const handleCloseAddProjectModal = () => setShowAddProjectModal(false);
    const handleShowAddProjectModal = () => setShowAddProjectModal(true);

    // Edit Project Modal start
    const [showEditProjectModal, setShowEditProjectModal] = React.useState(false);
    const handleCloseEditProjectModal = () => setShowEditProjectModal(false);
    const handleShowEditProjectModal = () => setShowEditProjectModal(true);

    // Delete Project Modal start
    const [showDeleteProjectModal, setShowDeleteProjectModal] = React.useState(false);
    const handleCloseDeleteProjectModal = () => setShowDeleteProjectModal(false);
    const handleShowDeleteProjectModal = () => setShowDeleteProjectModal(true);

    // Add Task Modal start
    const [showAddPTaskModal, setShowAddPTaskModal] = React.useState(false);
    const handleCloseAddPTaskModal = () => setShowAddPTaskModal(false);
    const handleShowAddPTaskModal = () => setShowAddPTaskModal(true);

    // ================== PERMISSION CHECK AFTER ALL HOOKS ==================
    // Only allow users with project permissions to access this page
    if (!MatchPermission(['Add Project', 'View Project', 'Edit Project', 'Delete Project', 'Project All'])) {
        return (
            <div className="p-4 text-center">
                <h4>Access Denied</h4>
                <p>You don't have permission to view projects.</p>
            </div>
        );
    }

    return (
        <>
            <div className="p-4">
                <MiniProjectList
                    showAddModal={setShowAddProjectModal}
                    showEditModal={setShowEditProjectModal}
                    showDeleteModal={setShowDeleteProjectModal}
                    handleShowAddPTaskModal={handleShowAddPTaskModal}
                />

                <AddMiniProjectModal
                    show={showAddProjectModal}
                    handleClose={handleCloseAddProjectModal}
                />
                <EditMiniProjectModal
                    show={showEditProjectModal}
                    handleClose={handleCloseEditProjectModal}
                />
                <DeleteProjectModal
                    show={showDeleteProjectModal}
                    handleClose={handleCloseDeleteProjectModal}
                />
                <AddTaskModal
                    show={showAddPTaskModal}
                    handleClose={handleCloseAddPTaskModal}
                />
            </div>
        </>
    )
}

export default ProjectIndex;
